import { render, staticRenderFns } from "./PhdProposal.vue?vue&type=template&id=ceaa6434&scoped=true&"
import script from "./PhdProposal.vue?vue&type=script&lang=js&"
export * from "./PhdProposal.vue?vue&type=script&lang=js&"
import style0 from "./PhdProposal.vue?vue&type=style&index=0&id=ceaa6434&prod&lang=scss&"
import style1 from "./PhdProposal.vue?vue&type=style&index=1&id=ceaa6434&prod&lang=scss&scoped=true&"
import style2 from "./PhdProposal.vue?vue&type=style&index=2&id=ceaa6434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaa6434",
  null
  
)

export default component.exports